// extracted by mini-css-extract-plugin
export default {"root":"cS2jGW"};